module.exports = __webpack_public_path__ + "media/images/health-partners-logo-58a4a2656e4dbdc6c6de1d5b03642f36.webp";